'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'pen-nib';
var width = 512;
var height = 512;
var aliases = [10001];
var unicode = 'f5ad';
var svgPathData = 'M396.7 198.1L466.7 128 384 45.3l-70.1 70.1 82.7 82.7zM381 227.7L284.3 131 121.7 185.2 40.6 448.7 152.9 336.5c-5.6-9.5-8.9-20.6-8.9-32.5c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64c-11.9 0-23-3.2-32.5-8.9L63.3 471.4l263.6-81.1L381 227.7zM352 416L40 512 0 472 96 160 288 96l73.4-73.4L384 0l22.6 22.6 82.7 82.7L512 128l-22.6 22.6L416 224 352 416zM176 304a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPenNib = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;